import React, { FC } from 'react';
import { WidgetProps } from '@wix/yoshi-flow-editor';
import { TPAComponentsProvider } from '@wix/wix-ui-tpa/cssVars';

import FolderTable from './Components/FolderTable/FolderTable';
import { st, classes } from './Widget.st.css';
import { AppContextProvider } from './Shared/AppContext';
import { useWidgetSetup } from './Hooks/useWidgetSetup.Hook';
import type { ControllerProps } from './types';

export type { ControllerProps };

const Widget: FC<WidgetProps<ControllerProps>> = (props: ControllerProps) => {
  const { selectedFolderIdFromSettings, breadCrumbs, rtlStatus } =
    useWidgetSetup(props);
  const compId = props.compId ?? props.id;

  return (
    <TPAComponentsProvider value={{}}>
      <AppContextProvider value={{ compId }}>
        {selectedFolderIdFromSettings === undefined ? null : (
          <div
            data-hook="shared-folder-root"
            tabIndex={0}
            aria-label={`Shared Folder: ${
              breadCrumbs && breadCrumbs[0]?.value
            }`}
            className={st(classes.root, {})}
            dir={rtlStatus}
          >
            <div className={st(classes.widgetContainer, {})}>
              <FolderTable />
            </div>
          </div>
        )}
      </AppContextProvider>
    </TPAComponentsProvider>
  );
};

export default Widget;
